Object.defineProperty(exports, "__esModule", {
  value: true
});

var rotatePoints_1 = require("./rotatePoints");

var constants_1 = require("../constants");

var distance_1 = require("../utilities/distance");

var computeAbsoluteOrigin_1 = require("./computeAbsoluteOrigin");

function normalizePoints(absolute, originX, originY, ns) {
  var len = ns.length;

  if (ns[len - 2] !== ns[0] || ns[len - 1] !== ns[1]) {
    return;
  }

  if (!absolute) {
    var relativeOrigin = computeAbsoluteOrigin_1.computeAbsoluteOrigin(originX, originY, ns);
    originX = relativeOrigin.x;
    originY = relativeOrigin.y;
  }

  var buffer = ns.slice(2);
  len = buffer.length;
  var index, minAmount;

  for (var i = 0; i < len; i += 6) {
    var next = distance_1.distance(originX, originX, buffer[i], buffer[i + 1]);

    if (minAmount === constants_1._ || next < minAmount) {
      minAmount = next;
      index = i;
    }
  }

  rotatePoints_1.rotatePoints(buffer, index);
  ns[0] = buffer[len - 2];
  ns[1] = buffer[len - 1];

  for (var i = 0; i < buffer.length; i++) {
    ns[i + 2] = buffer[i];
  }
}

exports.normalizePoints = normalizePoints;